module.exports = __webpack_public_path__ + "img/hele-billedet-1.4f084af7.png";